module.exports = "<svg id=\"Calque_1\" data-name=\"Calque 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11.25 27.63\"><title>border-tree</title><line x1=\"1.63\" y1=\"26.17\" x2=\"1.63\" y2=\"0.77\" style=\"fill:none;stroke:#c9c9c9;stroke-linecap:round;stroke-miterlimit:10;stroke-width:1px\"/><line x1=\"1.61\" y1=\"26.17\" x2=\"9.89\" y2=\"26.17\" style=\"fill:none;stroke:#c9c9c9;stroke-linecap:round;stroke-miterlimit:10;stroke-width:1px\"/></svg>\n"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/border-tree-corner.svg
// module id = 551
// module chunks = 0